import { View, ViewModel } from "binder";
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
export interface IPropertyTypeVisitor{
    VisitImagePropertyType(arg0: ImagePropertyType, parameter: any): any;
    VisitClassListPropertyType(arg0: ClassListPropertyType, parameter: any): any;
    VisitDatePropertyType(arg0: DatePropertyType, parameter: any): any;
    VisitBooleanPropertyType(arg0: BooleanPropertyType, parameter: any): any;
    VisitVmFunctionPropertyType(arg0: VmFunctionPropertyType, parameter: any): any;
    VisitCustomPropertyType(arg0: CustomPropertyType, parameter: any): any;
    VisitListPropertyType(arg0: ListPropertyType, parameter: any): any;
    VisitTemplateSelectorPropertyType(arg0: TemplateSelectorPropertyType, parameter: any): any;
    VisitIntegerPropertyType(arg0: IntegerPropertyType, parameter: any): any;
    VisitFloatPropertyType(arg0: FloatPropertyType, parameter: any): any;
    VisitTemplatePropertyType(arg0: TemplatePropertyType, parameter: any): any;
    VisitContentPropertyType(arg0: ContentPropertyType, parameter: any): any;
    VisitStringPropertyType(arg0: StringPropertyType, parameter: any): any;
    VisitFontWeightPropertyType(arg0: FontWeightPropertyType, parameter: any): any;
    VisitFontStylePropertyType(arg0: FontStylePropertyType, parameter: any): any;
}
export abstract class PropertyType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    abstract Accept(visitor:IPropertyTypeVisitor,parameter:any):any;
}

export class StringPropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitStringPropertyType(this,parameter);
    }
        
}

export class ImagePropertyType extends StringPropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitImagePropertyType(this,parameter);
    }
        
}
export class ClassListPropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitClassListPropertyType(this,parameter);
    }
        
}


export class ContentPropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitContentPropertyType(this,parameter);
    }

}

export class TemplatePropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitTemplatePropertyType(this,parameter);
    }
}


export class IntegerPropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitIntegerPropertyType(this,parameter);
    }
}

export class FloatPropertyType extends PropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitFloatPropertyType(this,parameter);
    }
}

export class TemplateSelectorPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitTemplateSelectorPropertyType(this,parameter);
    }
}

export class ListPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitListPropertyType(this,parameter);
    }
}


export class VmFunctionPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitVmFunctionPropertyType(this,parameter);
    }
}


export class BooleanPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitBooleanPropertyType(this,parameter);
    }
}
export class DatePropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitDatePropertyType(this,parameter);
    }
}

export class FontWeightPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitFontWeightPropertyType(this,parameter);
    }
}
export class FontStylePropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitFontStylePropertyType(this,parameter);
    }
}


export abstract class CustomPropertyType extends TemplatePropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    Accept(visitor: IPropertyTypeVisitor, parameter: any):any {
        return visitor.VisitCustomPropertyType(this,parameter);
    }

    abstract getEditor(parent:ViewModel) : IStaticValueProvider
}


